import React from "react";
import "./footer.css";
import { useSiteContent } from "../../context/SiteContentContext";
import { OfficialBrand } from "../navbar/navbar";
import { SiteLink } from "../site/siteText";

function Footer() {
  const { siteContent } = useSiteContent();
  const footer = siteContent.siteFooter || {};
  const links = Array.isArray(footer.links) ? footer.links : [];

  return (
    <footer className="footer">
      <div className="container footer-group">
        <OfficialBrand name={footer.brandName} tagline={footer.tagline} className="official-brand-footer" />
        <div>
          {links.map((link, i) => (
            <SiteLink key={`${link.to}-${i}`} to={link.to}>
              {link.label}
            </SiteLink>
          ))}
        </div>
        <p>{footer.companies}</p>
        <small>© {new Date().getFullYear()} {footer.copyrightBrand}</small>
      </div>
    </footer>
  );
}

export default Footer;
